import { Link } from 'gatsby';
import moment from 'moment';
import { PropTypes } from 'prop-types';
import React from 'react';

import Facebook from '../../../assets/svg/facebook.svg';
import LinkedIn from '../../../assets/svg/linkedin.svg';
import Twitter from '../../../assets/svg/twitter.svg';
import StoryShimCursor from './StoryShimCursor';

const StoryEnd = ({ data, location }) => {
  const {
    header = '',
    photographyCredits = '',
    publishedDate = '',
    relatedLinks = [],
    tags = [],
  } = data;

  return (
    <div className="story__end">
      <StoryShimCursor />
      <div className="story__end--text">
        <h6>{header}</h6>
        <div className="social-media" data-module-id="story_end">
          <a
            data-tracking-event="share"
            data-tracking-method="Facebook"
            href={`https://www.facebook.com/sharer/sharer.php?u=${location.href}`}
            rel="noreferrer"
            target="_blank"
          >
            <Facebook />
          </a>
          <a
            data-tracking-event="share"
            data-tracking-method="Twitter"
            href={`http://twitter.com/share?url=${location.href}`}
            rel="noreferrer"
            target="_blank"
          >
            <Twitter />
          </a>
          <a
            data-tracking-event="share"
            data-tracking-method="LinkedIn"
            href={`https://www.linkedin.com/shareArticle?mini=true&url=${location.href}`}
            rel="noreferrer"
            target="_blank"
          >
            <LinkedIn />
          </a>
        </div>
        <div className="info">
          <div className="info__left">
            <div className="date">
              {moment(publishedDate).format('MMM DD, YYYY')}
            </div>
            {photographyCredits && (
              <div className="credits">
                <span>Photographed by</span>
                <p className="credits__names">
                  {photographyCredits.map(({ name }) => name)}
                </p>
              </div>
            )}
          </div>
          <div className="tags">
            {tags.map(({ name, slug, type }) => {
              return (
                <Link key={slug} to={`/${type}/${slug}/`}>
                  {name}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
      <div className="story__end--divider" />
      <div className="story__end--related-links">
        <div className="intro">You might like these, too</div>
        {relatedLinks.map((link) => {
          const {
            internal: { type: typename },
            podcast,
            slug,
            title,
          } = link;
          const typeMap = {
            ContentfulArticleList: `/article/${slug}/`,
            ContentfulArticleLongForm: podcast
              ? `/podcast/${slug}/`
              : `/article/${slug}/`,
            ContentfulStory: `/story/${slug}/`,
          };
          return (
            <div key={title} className="related-links">
              <Link to={typeMap[typename]}>{title}</Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};

StoryEnd.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};

export default StoryEnd;
